import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import { Amplify } from "aws-amplify";

loadFonts();
async function initApp() {
  Amplify.configure({
    Auth: {
      Cognito: {
        // identityPoolId: "us-east-1:5d51df7e-d160-43db-bed7-0f636d93fd76",
        userPoolId: "ap-south-1_VmMF1JinB",
        userPoolClientId: "bp5iab1u2k5c019p0adfgsvqv",
        loginWith: {
          email: true,
        },
        signUpVerificationMethod: "code",
      },
    },
    // Storage: {
    //   S3: {
    //     bucket: "slts-app-users",
    //     region: "us-east-1",
    //   },
    // },
    API: {
      GraphQL: {
        endpoint:
          "https://dz5he4ditfevjl53f3al5e4ssi.appsync-api.ap-south-1.amazonaws.com/graphql",
        region: "ap-south-1",
        defaultAuthMode: "userPool",
      },
    },
  });
}
initApp().then(() => {
  createApp(App).use(router).use(store).use(vuetify).mount("#app");
});

